var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meta-item-back m-4"},[_c('i',{staticClass:"icon icon-bor-arrow-left"}),_c('a',{staticClass:"text-black",on:{"click":_vm.handleBack}},[_vm._v("お申し込み一覧に戻る")])])}
var staticRenderFns = []

export { render, staticRenderFns }